import React from 'react';
import BeforeAfterSlider from './BeforeAfterSlider';
import preFractureImage from '../../assets/Pre Fracture.jpg';
import postFractureImage from '../../assets/Post Fracture.jpg';
import preBleachImage from '../../assets/Pre bleach.jpg';
import postBleachImage from '../../assets/Post bleach.jpg';
import implant46Pre from '../../assets/Implant_46_Pre.jpeg';
import implant46Post from '../../assets/Implant_46_Post.bmp';
import implant47Pre from '../../assets/Implant_47_Pre.jpeg';
import implant47Post from '../../assets/Implant_47_Post.bmp';
import intraCanalPre from '../../assets/Intra_Canal_Pre.jpg';
import intraCanalPost from '../../assets/Intra_Canal_Post.jpg';
import pfmCrownPre from '../../assets/PFM_Crown_Pre.jpg';
import pfmCrownPost from '../../assets/PFM_Crown_Post.jpg';
import zirconiaPre from '../../assets/Zirconia_Pre.jpg';
import zirconiaPost from '../../assets/Zirconia_Post.jpg';
import { useNavigate } from 'react-router';

const BeforeAfterGallery = () => {
  const navigate = useNavigate();

  // Sample cases data array - this makes the number of comparisons dynamic
  const cases = [
    {
      id: 1,
      title: "Fracture Tooth",
      beforeImg: preFractureImage,
      afterImg: postFractureImage
    },
    {
      id: 2,
      title: "Bleaching",
      beforeImg: preBleachImage,
      afterImg: postBleachImage
    },
    {
      id: 3,
      title: "Zirconia Crown & Filling",
      beforeImg: zirconiaPre,
      afterImg: zirconiaPost
    },
    {
      id: 4,
      title: "PFM Crown",
      beforeImg: pfmCrownPre,
      afterImg: pfmCrownPost
    },
    {
      id: 5,
      title: "Root Canal Treatment",
      beforeImg: intraCanalPre,
      afterImg: intraCanalPost
    },
    {
      id: 6,
      title: "Implant 46",
      beforeImg: implant46Pre,
      afterImg: implant46Post
    },
    {
      id: 7,
      title: "Implant 47",
      beforeImg: implant47Pre,
      afterImg: implant47Post
    },
    // You can add more cases here and the grid will automatically adjust
  ];

  return (
    <div className="max-w-6xl mx-auto px-4 py-12">
      <h2 className="text-4xl text-center font-semibold mb-3 text-gray-800">Smile Transformations</h2>
      <p className="text-center mb-12 text-teal-600">See the difference we can make</p>
      
      <div className="grid md:grid-cols-2 lg:grid-cols-2 gap-8">
        {cases.map(caseItem => (
          <div key={caseItem.id} className="bg-white rounded-lg shadow-lg overflow-hidden">
            <BeforeAfterSlider
              title={caseItem.title}
              beforeImg={caseItem.beforeImg}
              afterImg={caseItem.afterImg}
            />
            <div className="p-4 border-t border-gray-100">
              <h3 className="font-medium text-xl text-teal-600">{caseItem.title}</h3>
              {/* <div className="flex mt-3">
                <span className="bg-lime-500 text-white px-3 py-1 rounded-full text-sm font-medium mr-2">Before</span>
                <span className="bg-teal-500 text-white px-3 py-1 rounded-full text-sm font-medium">After</span>
              </div> */}
            </div>
          </div>
        ))}
      </div>
      
      <div className="text-center mt-12">
        <button onClick={() => navigate('/schedule-appointment')} className="cursor-pointer bg-teal-600 hover:bg-teal-700 text-white font-medium py-2 px-6 rounded-full shadow-md transition duration-300">
          Book Your Consultation
        </button>
      </div>
    </div>
  );
};

export default BeforeAfterGallery;